/**
 * Initialize the post type filter.
 *
 * @param {Function} callback The callback function to execute after processing.
 */
const init = (callback) => {
	// Check if post type filter elements exist
	const postTypeFilters = document.querySelectorAll(
		'.js-gsfc-filter-post-type'
	);
	if (postTypeFilters.length > 0) {
		// Event handler for click on post type filter
		postTypeFilters.forEach((postTypeFilter) => {
			postTypeFilter.addEventListener('click', async function (e) {
				e.preventDefault();
				// Scroll to feed anchor with smooth behavior
				document.getElementById('filterWrapper').scrollIntoView({
					behavior: 'smooth',
				});
				await process(this);
				callback();
			});
		});
		// Set flag to query post types
		global.filters.query_postTypes = true;
	}
};

/**
 * Process the post type filter.
 *
 * @param {HTMLElement} elem The element representing the post type filter.
 * @return {Promise} A Promise that resolves after processing the filter.
 */
const process = (elem) => {
	return new Promise((resolve) => {
		const value = elem.dataset.postType;

		// Update global filters based on selected post type value
		if (value === 'all') {
			global.filters.post_types = [];
		} else {
			global.filters.post_types = [value];
			// Remove active class from other post type filters and add to current filter
			document
				.querySelectorAll('.js-gsfc-filter-post-type')
				.forEach((filter) => {
					filter.classList.remove('active');
				});
			elem.classList.add('active');
		}
		resolve();
	});
};

/**
 * Update the post type filter.
 */
const update = () => {
	// Add active class to post type filters based on global filters
	const postTypeFilters = document.querySelectorAll(
		'.js-gsfc-filter-post-type'
	);
	if (
		global.filters.post_types !== undefined &&
		global.filters.post_types.length > 0
	) {
		const postTypes = global.filters.post_types;
		postTypeFilters.forEach((postTypeFilter) => {
			if (postTypes.includes(postTypeFilter.dataset.postType)) {
				postTypeFilter.classList.add('active');
			}
		});
	}
};

// Export the post type filter methods
export default { init, update };
